import { GoGear } from 'react-icons/go'
import { TiArrowMinimiseOutline } from 'react-icons/ti'

import type { ILink } from '@base/@types/components/Layout/Navigator'
const optimizerLinks: ILink = {
  group: 'Otimizador',
  icon: <GoGear />,
  roles: ['Administrador', 'AnalistaPlanejamento'],
  menu: [
    {
      name: 'Otimizador de Estoque',
      path: '/otimizador/estoque',
      icon: <GoGear />,
      description: 'Otimizar os estoque de loja ',
      roles: ['Administrador', 'AnalistaPlanejamento']
    },
    {
      name: 'Config de Param Default',
      path: '/otimizador/default',
      icon: <TiArrowMinimiseOutline />,
      description: 'Configuração de Paramêtros Default (Mínimo e Máximo)  ',
      roles: ['Administrador', 'AnalistaPlanejamento']
    }
  ]
}

export default optimizerLinks
